import {
  cardContainer,
  quoteContainer,
  imageContainer,
  nameContainer,
} from "./styles.css";
import { AccentText } from "../../typography";
import { CmsImage } from "../cms-image";

export type PersonCardProps = {
  image: "string";
  name: string;
  quote: string;
};

export const PersonCard = ({ quote, name, image }: PersonCardProps) => {
  return (
    <div className={cardContainer}>
      <div className={imageContainer}>
        {<CmsImage image={image} alt={name} />}
      </div>
      <div className={nameContainer}>
        <p>{name}</p>
      </div>
      <div className={quoteContainer}>
        <p>
          <AccentText>{quote}</AccentText>
        </p>
      </div>
    </div>
  );
};
